import { FC } from "react"

export const SHOW_NOT_IMPLEMENTED = "debug.showNotImplemented"

export const NotImplemented: FC = ({ children }) => (
  <>{localStorage.getItem(SHOW_NOT_IMPLEMENTED) === "true" ? children : null}</>
)
